<div class="alert-dialog">
  <header class="alert-dialog__header">
    <h2 class="alert-dialog__title">{{ data?.alert ? 'Editar alerta' : 'Novo alerta' }}</h2>
    <button type="button" class="icon-button" aria-label="Fechar" (click)="cancel()">×</button>
  </header>

  <form class="alert-dialog__body" [formGroup]="form" [appSkeleton]="loadingCatalog()" (submit)="$event.preventDefault(); save()">
    <div class="inline-field">
      <span class="inline-label">Nome</span>
      <input type="text" formControlName="name" placeholder="Ex.: Pluvia até 21h" />
    </div>

    <div class="inline-field status-field">
      <span class="inline-label">Status</span>
      <mat-slide-toggle color="primary" formControlName="enabled" aria-label="Alerta ativo">
        {{ formSnapshot().enabled ? 'Ativo' : 'Inativo' }}
      </mat-slide-toggle>
    </div>

    <div class="target-block">
      <span class="inline-label">Alvo</span>
      <div class="target-picker">
        @if (legacySeriesLabel()) {
          <p class="legacy-series">{{ legacySeriesLabel() }}</p>
        }
        @if (catalogError()) {
          <p class="hint">{{ catalogError() }}</p>
        }
        @if (loadingCatalog() && !sources().length) {
          <div class="tree-scroll" aria-hidden="true">
            @for (row of catalogSkeleton; track row) {
              <div class="tree-row">
                <span class="chevron"></span>
                <span class="tree-name">Fonte de dados</span>
              </div>
            }
          </div>
        } @else if (!catalogError() && !sources().length) {
          <p class="hint">Nenhuma fonte encontrada.</p>
        } @else if (sources().length) {
          <div class="tree-scroll" role="tree" aria-label="Fontes e datasets">
            @for (node of treeRows(); track node.source._id) {
              <div class="tree-row" role="treeitem" [attr.aria-expanded]="node.open">
                <button
                  type="button"
                  class="chevron"
                  [class.chevron--open]="node.open"
                  [attr.aria-label]="(node.open ? 'Recolher ' : 'Expandir ') + node.source.name"
                  (click)="toggleExpanded(node.source._id)"
                >
                  <span class="chevron-icon"></span>
                </button>
                <input
                  type="checkbox"
                  [checked]="node.checked"
                  [disabled]="node.disabled"
                  [attr.aria-label]="'Fonte ' + node.source.name"
                  (change)="toggleSource(node.source._id)"
                />
                <button type="button" class="tree-name" [title]="node.source.name" (click)="toggleExpanded(node.source._id)">
                  {{ node.source.name }}
                </button>
              </div>
              @if (node.open) {
                @if (node.showLoading) {
                  <div [appSkeleton]="true" aria-hidden="true">
                    @for (row of datasetSkeleton; track row) {
                      <div class="tree-row tree-row--child">
                        <span class="tree-name">Dataset</span>
                      </div>
                    }
                  </div>
                }
                @for (row of node.datasets; track row.dataset._id) {
                  <div class="tree-row tree-row--child" role="treeitem">
                    <label class="tree-check">
                      <input
                        type="checkbox"
                        [checked]="row.checked"
                        [disabled]="row.disabled"
                        [attr.aria-label]="row.ariaLabel"
                        (change)="toggleDataset(row.dataset._id)"
                      />
                      <span class="tree-name" [title]="row.dataset.name">{{ row.dataset.name }}</span>
                    </label>
                  </div>
                }
                @if (node.showEmpty) {
                  <p class="tree-note">Nenhum dataset nesta fonte.</p>
                }
              }
            }
          </div>
        }
      </div>
    </div>

    <div class="when-block">
      <div class="when-row">
        <span class="inline-label">Quando</span>
        <div class="segmented" role="radiogroup" aria-label="Tipo do alerta">
          <button type="button" [class.active]="formSnapshot().kind === 'event'" (click)="setKind('event')">Evento</button>
          <button type="button" class="freshness-kind" [class.active]="formSnapshot().kind === 'freshness'" (click)="setKind('freshness')">
            Freshness
            <tooltip class="kind-info" [tooltip]="freshnessKindTooltip">
              <mat-icon svgIcon="Info Circle"></mat-icon>
            </tooltip>
          </button>
        </div>
      </div>
      @if (formSnapshot().kind === 'event') {
        <div class="when-options">
          <label class="check">
            <input type="checkbox" formControlName="executionCreated" />
            <span>Nova execução</span>
          </label>
          <label class="check">
            <input type="checkbox" formControlName="executionCompleted" />
            <span>Concluída</span>
          </label>
          <label class="check">
            <input type="checkbox" formControlName="executionFailed" />
            <span>Falha</span>
          </label>
        </div>
      }
      @if (formSnapshot().kind === 'freshness') {
        <div class="when-options">
          <div class="segmented" role="radiogroup" aria-label="Frequência">
            <button type="button" [class.active]="formSnapshot().frequency === 'daily'" (click)="setFrequency('daily')">Diário</button>
            <button type="button" [class.active]="formSnapshot().frequency === 'weekly'" (click)="setFrequency('weekly')">Semanal</button>
            <button type="button" [class.active]="formSnapshot().frequency === 'monthly'" (click)="setFrequency('monthly')">Mensal</button>
          </div>
          <label class="freshness-field">
            <span class="freshness-field__label">Horário</span>
            <input class="time" type="time" formControlName="deadlineTime" aria-label="Horário" />
          </label>
          @if (formSnapshot().frequency === 'daily') {
            <div class="freshness-field weekday-field">
              <span class="freshness-field__label">Dias</span>
              <div class="weekday-picks" role="group" aria-label="Dias da semana">
                @for (day of weekdays; track day.value) {
                  <label class="check">
                    <input
                      type="checkbox"
                      [checked]="isWeekdaySelected(day.value)"
                      [attr.aria-label]="day.label"
                      (change)="toggleWeekday(day.value)"
                    />
                    <span>{{ day.short }}</span>
                  </label>
                }
              </div>
            </div>
          }
          @if (formSnapshot().frequency === 'weekly') {
            <label class="freshness-field">
              <span class="freshness-field__label">Dia da semana</span>
              <select formControlName="weekday" aria-label="Dia da semana">
                @for (day of weekdays; track day.value) {
                  <option [value]="day.value">{{ day.label }}</option>
                }
              </select>
            </label>
          }
          @if (formSnapshot().frequency === 'monthly') {
            <label class="freshness-field">
              <span class="freshness-field__label">Dia do mês</span>
              <input class="day" type="number" min="1" max="31" formControlName="dayOfMonth" aria-label="Dia do mês" />
            </label>
          }
        </div>
      }
    </div>

    <div class="emails-block">
      <div class="inline-field">
        <span class="inline-label">E-mails</span>
        <input
          type="email"
          [value]="emailDraft()"
          (input)="onEmailDraft($any($event.target).value)"
          (keydown.enter)="$event.preventDefault(); addEmail()"
          placeholder="nome@empresa.com.br"
          aria-label="E-mail"
        />
        <button type="button" class="icon-add" aria-label="Adicionar e-mail" (click)="addEmail()">
          <mat-icon svgIcon="Plus"></mat-icon>
        </button>
      </div>
      @if (emailError()) {
        <p class="field-error" role="alert">{{ emailError() }}</p>
      }
      @if (emails().length) {
        <ul class="chips">
          @for (email of emails(); track email) {
            <li>
              {{ email }}
              <button type="button" [attr.aria-label]="'Remover ' + email" (click)="removeEmail(email)">×</button>
            </li>
          }
        </ul>
      }
    </div>

    <footer class="alert-dialog__footer">
      @if (errorMessage()) {
        <p class="form-error" role="alert">{{ errorMessage() }}</p>
      }
      <div class="footer-end">
        @if (data?.alert) {
          <button type="button" class="danger-button" [disabled]="deleting() || saving()" (click)="askDelete()">
            Excluir
          </button>
        }
        <button-induxtry [buttonProperties]="saveButton()"></button-induxtry>
      </div>
    </footer>
  </form>
</div>
